import { forwardRef } from 'react';
import type { BusinessIconImageProps } from '../businessTypes';

const PartnersOutlined = forwardRef<SVGSVGElement, BusinessIconImageProps>(
  ({ size = 24, width, height, alt = '', color = 'currentColor', strokeWidth, style, ...props }, ref) => (
    <svg
      ref={ref}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      strokeWidth={strokeWidth}
      width={width ?? size}
      height={height ?? size}
      role={alt ? 'img' : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
      style={{ color, ...style }}
      {...props}
    >
      <g clipPath="url(#clip0_369_96)">
        <path d="M12 9.65343L8.69657 6.35C8.07076 5.72419 7.22199 5.37262 6.33697 5.37262C5.45195 5.37262 4.60318 5.72419 3.97738 6.35C3.35157 6.9758 3 7.82457 3 8.70959C3 9.59461 3.35157 10.4434 3.97738 11.0692L12 19.0918L20.0226 11.0692C20.6484 10.4434 21 9.59461 21 8.70959C21 7.82457 20.6484 6.9758 20.0226 6.35C19.3968 5.72419 18.548 5.37262 17.663 5.37262C16.778 5.37262 15.9292 5.72419 15.3034 6.35L12 9.65343Z" stroke="currentColor" strokeWidth={strokeWidth ?? "1.41576"} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.1848 11.1418L14.3594 15.3165" stroke="currentColor" strokeWidth={strokeWidth ?? "1.41576"} strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_369_96">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  ),
);

PartnersOutlined.displayName = 'PartnersOutlined';

export default PartnersOutlined;
